var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-overview',{attrs:{"add-label":"compose","controller":"Mail","filter":_vm.Filter,"visible":_vm.visible},scopedSlots:_vm._u([{key:`read-incoming`,fn:function(item){return [_c('v-icon',{attrs:{"color":item.incoming.value ? 'green' : 'red'}},[_vm._v(" mdi-arrow-"+_vm._s(item.incoming.value ? 'down' : 'up')+" ")])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }